import { useI18n } from "./context";
import { TranslationKeys, translations } from "./translations";

export const Text: React.FC<{ id: TranslationKeys }> = ({ id }) => {
  const i18n = useI18n();

  return translations[id][i18n.language];
};

export const TextWithFallback: React.FC<{
  id: string;
  fallbackId: TranslationKeys;
}> = ({ id, fallbackId }) => {
  const i18n = useI18n();

  return id in translations
    ? translations[id as TranslationKeys][i18n.language]
    : translations[fallbackId][i18n.language];
};
